import clsx from "clsx";
import React from "react";

export const Label = ({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) => {
    return (
        <label
            className={clsx("pt-4 pb-1 text-sm font-semibold text-[#424242]", className)}
            {...props}
        />
    );
};
